import Vue from 'vue';
import Router from 'vue-router';
import index from '@/views/layout/index';
import kolLayout from '@/views/layout/kolLayout';
import gbaLayout from '@/views/layout/gbaLayout';
import gaAdminLayout from '@/views/layout/gaAdminLayout';
import publicLayout from '@/views/layout/external';
import {getLocalStorage, isEnableAI, isSalesManagerTerritory, isSpecialSalesOverviewRole} from '@/utils/index';
import {LogUserVisits} from '@/api/user';
import * as moment from 'moment';

Vue.use(Router);

const routerMothods = ['push', 'replace'];
routerMothods.map((method) => {
  const VueRouterCall = Router.prototype[method];

  Router.prototype[method] = function (location, onComplete, onAbort) {
    if (onComplete || onAbort) {
      return VueRouterCall.call(this, location, onComplete, onAbort);
    }
    return VueRouterCall.call(this, location).catch((err) => {
      console.log({path: location, msg: err});
    });
  };
});

var router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/hcp',
      redirect: '/hcp/home',
      component: index,
      children: [
        {
          path: 'overview',
          name: 'overview',
          component: () =>
            (isSalesManagerTerritory() || isSpecialSalesOverviewRole())
              ? import(/* webpackChunkName: "hcp" */ '@/views/hcp/managerOverview.vue')
              : import(/* webpackChunkName: "hcp" */ '@/views/hcp/overview.vue'),
        },
        {
          path: 'home',
          redirect: () => (isSalesManagerTerritory() || isEnableAI() ? '/hcp/overview' : '/hcp/list'),
        },
        {
          path: 'department',
          name: 'departmentList',
          component: () =>
            import(
              /* webpackChunkName: "hcp" */ '@/views/hcp/departmentList.vue'
            ),
        },
        {
          path: 'list',
          name: 'list',
          component: () =>
            import(/* webpackChunkName: "hcp" */ '@/views/hcp/home.vue'),
        },
        {
          path: 'detail',
          name: 'hcp',
          component: () =>
            import(/* webpackChunkName: "hcp" */ '@/views/hcp/details.vue'),
        },
        {
          path: 'visit-list',
          name: 'visitListHome',
          component: () => import('@/views/hcp/visit-list.vue'),
        },
        {
          path: 'nba-list',
          name: 'nbaListHome',
          component: () => import('@/views/hcp/nba-list.vue'),
        },
        {
          path: 'insight-list',
          name: 'insightListHome',
          component: () => import('@/views/kol/insight-list.vue'),
        },
        {
          path: 'visit-create',
          name: 'visitCreate',
          component: () => import('@/views/hcp/VisitCreate.vue'),
        },
        {
          path: 'content',
          name: 'contentHome',
          component: () => import('@/views/hcp/contentList.vue'),
        },
        {
          path: 'report',
          name: 'reportHome',
          component: () => import('@/views/hcp/report.vue'),
        },
        {
          path: 'team',
          name: 'teamHome',
          component: () => import('@/views/hcp/team.vue'),
        },
        {
          path: 'task-summary-detail',
          name: 'taskSummaryDetail',
          component: () => import('@/views/hcp/taskSummaryDetail.vue'),
        },
        {
          path: '/approval',
          name: 'Approval',
          component: () => import('@/views/hcp/approval-list.vue'),
        },
        {
          path: 'live',
          name: 'Live',
          component: () => import('@/views/hcp/live.vue'),
        },
        {
          path: 'task',
          name: 'task',
          component: () => import('@/views/hcp/task.vue'),
        },
        {
          path: 'task-management',
          name: 'task-management',
          component: () => import('@/views/hcp/task-management.vue'),
        },
        {
          path: 'blank',
          name: 'blank',
          component: () =>
            import(/* webpackChunkName: "hcp" */ '@/views/blank.vue'),
        },
      ],
    },
    {
      path: '/doctor-select',
      name: 'doctorSelect',
      component: () => import('@/components/DoctorListSelect.vue'),
    },
    {
      path: '/kol',
      component: kolLayout,
      children: [
        // {
        //   path: 'doctor-select',
        //   name: 'doctorSelect',
        //   component: () => import('@/components/DoctorListSelect.vue'),
        // },
        {
          path: 'visit-create',
          name: 'visitCreate',
          component: () =>
            import(/* webpackChunkName: "hcp" */ '@/views/kol/VisitCreate.vue'),
        },
        {
          path: 'insight-create',
          name: 'InsightCreate',
          component: () =>
            import(
              /* webpackChunkName: "hcp" */ '@/views/kol/InsightCreate.vue'
            ),
        },
        {
          path: 'home',
          name: 'KolHome',
          component: () => import('@/views/kol/home.vue'),
        },
        {
          path: 'department',
          name: 'departmentList',
          component: () =>
            import(
              /* webpackChunkName: "hcp" */ '@/views/kol/departmentList.vue'
            ),
        },
        {
          path: 'list',
          name: 'list',
          component: () =>
            import(/* webpackChunkName: "hcp" */ '@/views/kol/list.vue'),
        },
        {
          path: 'doctor-list',
          name: 'doctorListHome',
          component: () => import('@/views/kol/home.vue'),
        },
        {
          path: 'detail',
          name: 'doctorDetailHome',
          component: () => import('@/views/kol/details.vue'),
        },
        {
          path: 'visit-list',
          name: 'visitListHome',
          component: () => import('@/views/kol/visit-list.vue'),
        },
        {
          path: 'insight-list',
          name: 'insightListHome',
          component: () => import('@/views/kol/insight-list.vue'),
        },
        {
          path: 'work',
          name: 'workHome',
          component: () => import('@/views/kol/work.vue'),
        },
        {
          path: 'work',
          name: 'workHome',
          component: () => import('@/views/kol/work.vue'),
        },
        {
          path: 'work-create',
          name: 'workCreate',
          component: () => import('@/views/kol/workCreate.vue'),
        },
        {
          path: 'report',
          name: 'reportHome',
          component: () => import('@/views/kol/report.vue'),
        },
      ],
    },
    {
      path: '/gba',
      component: gbaLayout,
      redirect: '/gba/overview',
      children: [
        {
          path: 'overview',
          name: 'gbaOverview',
          component: () => import('@/views/hcp/overview.vue'),
        },
        {
          path: 'list',
          name: 'gbaDoctorList',
          component: () => import('@/views/gba/list.vue'),
        },
        {
          path: 'detail',
          name: 'gbaDoctorDetail',
          component: () => import('@/views/gba/details.vue'),
        },
        {
          path: 'expert-detail',
          name: 'gbaExpertDetail',
          component: () => import('@/views/gba/expertDetails.vue'),
        },
        {
          path: 'visit-list',
          name: 'gbaVisitList',
          component: () => import('@/views/hcp/visit-list.vue'),
        },
        {
          path: 'visit-create',
          name: 'gbaVisitCreate',
          component: () => import('@/views/hcp/VisitCreate.vue'),
        },
        {
          path: 'live',
          name: 'Live',
          component: () => import('@/views/hcp/live.vue'),
        },
        {
          path: 'content',
          name: 'gbaContent',
          component: () => import('@/views/hcp/contentList.vue'),
        },
        {
          path: 'task',
          name: 'gbaTask',
          component: () => import('@/views/hcp/task.vue'),
        },
        {
          path: 'task-summary-detail',
          name: 'gbaTaskSummaryDetail',
          component: () => import('@/views/hcp/taskSummaryDetail.vue'),
        },
      ],
    },
    {
      path: '/ga-admin',
      component: gaAdminLayout,
      redirect: '/ga-admin/overview',
      children: [
        {
          path: 'overview',
          name: 'gaAdminOverview',
          component: () => import('@/views/gaAdmin/overview.vue'),
        },
        {
          path: 'customers',
          name: 'gaAdminCustomers',
          component: () => import('@/views/gaAdmin/customers.vue'),
        },
        {
          path: 'execution',
          name: 'gaAdminExecution',
          component: () => import('@/views/gaAdmin/execution.vue'),
        },
        {
          path: 'strategy',
          name: 'gaAdminStrategy',
          component: () => import('@/views/gaAdmin/strategy.vue'),
        },
      ],
    },
    {
      path: '/public',
      component: publicLayout,
      children: [
        {
          path: 'pim-callback',
          name: 'pimCallback',
          component: () => import('@/views/public/pim-callback.vue'),
        },
        {
          path: 'authorize',
          name: 'authorize',
          component: () => import('@/views/public/authorize.vue'),
        },
        {
          path: 'open',
          name: 'open',
          component: () => import('@/views/public/open.vue'),
        },
        {
          path: 'live',
          name: 'live',
          component: () => import('@/views/public/live.vue'),
        },
        {
          path: 'survey',
          name: 'survey',
          component: () => import('@/views/public/survey.vue'),
        },
        {
          path: 'register',
          name: 'register',
          component: () => import('@/views/public/register.vue'),
        },
        // {
        //   path: 'hcp-confirmation',
        //   name: 'hcpConfirmation',
        //   component: () => import('@/views/public/hcpConfirmation.vue'),
        // },
        // {
        //   path: 'hcp-consent',
        //   name: 'hcpConsent',
        //   component: () => import('@/views/public/hcpConsent.vue'),
        // },
        {
          path: 'hcp-bind-success',
          name: 'hcpBindSuccess',
          component: () => import('@/views/public/hcpBindSuccess.vue'),
        },
      ],
    },

    // { path: '/nba', name: 'nba', component: () => import(/* webpackChunkName: "nba" */ '@/views/nba/index.vue') },
    // { path: '/follow', redirect: '/nba' },
    {
      path: '/login',
      name: 'login',
      component: () =>
        import(/* webpackChunkName: "login" */ '@/views/login.vue'),
    },
    // { path: '/', name: 'login', component: () => import(/* webpackChunkName: "login" */ '@/views/login.vue') },
    {
      path: '/sso',
      name: 'sso',
      component: () =>
        import(/* webpackChunkName: "login" */ '@/views/sso.vue'),
    },
    {
      path: '/authorize',
      name: 'authorize',
      component: () =>
        import(/* webpackChunkName: "login" */ '@/views/authorize.vue'),
    },
    {
      path: '/error',
      name: 'error',
      component: () =>
        import(/* webpackChunkName: "login" */ '@/views/error.vue'),
    },
    {path: '*', redirect: '/'},
  ],
});

/**
 * @description check whether user login
 */
async function authCheck(to, from, next) {
  next();
  // let token = '1';// store.state.user.token;
  // // let user_id = getLocalStorage('user_id') ? getLocalStorage('user_id') : '';
  // let user_id = "";
  // if (window.location.href.indexOf('?') > -1) {
  //   let urlParams = getURLParams(window.location.href);
  //   if (urlParams.user_id) {
  //     user_id = urlParams.user_id;
  //     setLocalStorage("user_id", user_id);
  //   }
  // } else if (getLocalStorage("user_id")) {
  //   user_id = getLocalStorage("user_id");
  // }
  // let data = {
  //   user_id: user_id,
  //   page: to.path,
  //   page_uri: to.fullPath,
  //   log_time_start: new Date(),
  //   page_param: store.state.doctor.doctorObj.physician_name,
  //   session: getLocalStorage('sessionId') ? getLocalStorage('sessionId') : ''
  // };
  // if (getToken().device_id) {
  //   systemLog(data).then(res => {
  //   });
  // }
  // if (token) {
  //   let pathArr = ['/', '/login', '/error', '/hcp/detail', '/authorize'];
  //   if (pathArr.includes(to.path)) {
  //     next();
  //   } else {
  //     if (user_id) {
  //       next();
  //     } else {
  //       next('/error');
  //     }
  //   }
  //   // try {
  //   // } catch {
  //   // }
  // } else {
  //   // 白名单
  //   next();
  // }
}

/**
 * Navigation Guards - beforeEach
 * @description check auth from vuex user token. Whether auth limit by router meta permission
 */
router.beforeEach((to, from, next) => {
  if (to.path === '/hcp/overview' && !isSalesManagerTerritory() && !isEnableAI()) {
    next('/hcp/list');
    return;
  }

  const data = {
    user_id: getLocalStorage('user_id') ? getLocalStorage('user_id') : '',
    role_id: getLocalStorage('role_id') ? getLocalStorage('role_id') : '',
    visit_time: moment().format('YYYY-MM-DD HH:mm:ss'),
    visit_page: to.path,
    visit_platform: 'mobile',
    visit_full_url: window.location.href,
  };
  LogUserVisits(data);
  authCheck(to, from, next);
});

export default router;
